/**
 * Official external URLs, centralized so they are defined once and never
 * hard-coded/duplicated across components.
 */

/** Official CAIXA responsible-gaming page. The previous loterias.caixa.gov.br URL for this page is obsolete/broken. */
export const RESPONSIBLE_GAMING_URL = "https://www.caixa.gov.br/jogo-responsavel/Paginas/default.aspx";

export const CAIXA_LOTOFACIL_URL = "https://loterias.caixa.gov.br/Paginas/Lotofacil.aspx";
export const CAIXA_MEGASENA_URL = "https://loterias.caixa.gov.br/Paginas/Mega-Sena.aspx";
